<ng-template portal="#secondaries">
  <button
    *breakpoints="['md', 'lg']"
    smw-button
    kind="icon"
    class="menu-trigger"
    [icon]="menuIcon"
    [menuTriggerFor]="menu"
    [position]="menuPosition"
  ></button>

  <ng-template #menu>
    <smw-process-menu
      [sections]="sections()"
      [steps]="steps()"
      [menuItemComponentsMapping]="stepItemComponentsMapping()"
    />
  </ng-template>
</ng-template>

<main class="container">
  <ng-content select="[process-heading]" />

  <h1 class="title-lg mb-6">
    <ng-content select="[process-title]" />
  </h1>

  <div class="wrapper">
    <div class="flex flex-col h-[fit-content] gap-2">
      <ng-content select="[process-menu-before]" />

      <smw-process-menu
        *breakpoints="['xl']"
        [sections]="sections()"
        [steps]="steps()"
        [menuItemComponentsMapping]="stepItemComponentsMapping()"
      />
    </div>

    @if (noSection()) {
      <div class="sectionless-steps">
        @for (step of steps(); track step) {
          @if (stepComponentsMapping()[step]; as component) {
            <ng-container *ngComponentOutlet="component" />
          }
        }
      </div>
    } @else {
      <div class="sections">
        @if (description(); as description) {
          <smw-process-description [resource]="description" />
        }
        @for (section of sections(); track section.id) {
          <smw-section
            [title]="section.title"
            [tooltip]="section.tooltip!"
            [bannerContent]="section.bannerContent"
          >
            @for (step of section.steps; track step) {
              @if (stepComponentsMapping()[step]; as component) {
                <ng-container *ngComponentOutlet="component" />
              }
            }
          </smw-section>
        }
      </div>
    }
  </div>
</main>
